module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-height"
  }, [_c('foobar-header'), _vm._v(" "), _c('intro'), _vm._v(" "), _c('section-intro', {
    attrs: {
      "title": _vm.$t('message.title.main.foobar_editor')
    }
  }), _vm._v(" "), _c('foobar-edit', {
    attrs: {
      "foobar-id": _vm.$route.params.id
    }
  }), _vm._v(" "), _c('foobar-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c8feb99"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/FoobarEditor.vue
// module id = 1826
// module chunks = 1